import { useRef, useEffect } from "react";
import { Link } from "react-router-dom";

import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
import { ScrollSmoother } from "gsap/ScrollSmoother";

import { scrollResizeControlClear, scrollResizeControlMake, smoother } from "../utils/scroll-resize";
import { waitForFinalEvent } from "../utils/utils";
import { pageInitState } from "../utils/config";

import { comingInit, comingScrollMake, comingResizeStart, comingResizeDone} from "../utils/page-coming-soon";

import videoBg from '../assets/video/fireworks-17735952-hd_1920_1080_30fps-optimized.mp4';

let comingMount1 = 0;
let comingMount2 = 0;

let comingReady = false;

function ComingSoon ({appLoaded, loadingOn, pageChangeOn, setPageChangeOn, pageOn, setPageOn, setCursorOn}) {
  const comingResizing = useRef(false);

  const comingRef = useRef(null);

  const videoRef = useRef(null);

  useEffect(() => {
    if(videoRef.current) {
      videoRef.current.defaultMuted = true;
      videoRef.current.muted = true;
    }
  }, []);

  useGSAP((context, contextSafe) => {
    comingMount1++;
    console.log(`Coming: useGSAP 1: [${comingMount1}]: [excute]`);

    let onComingResizeHandler = (e) => {
      if(!comingResizing.current) {
        console.log('[coming] Resize: START');

        comingResizing.current = true;

        if(comingReady) { // Do only coming page is ready
          comingResizeStart(gsap, ScrollTrigger, ScrollSmoother);
        }
      }

      waitForFinalEvent( function() {
        console.log('[coming] Resize: END');

        comingResizing.current = false;

        if(comingReady) { // Do only coming page is ready & resize start related functions executed
          ScrollTrigger.refresh(); // jess: After resizing done, refresh the ScrollTrigger

          comingResizeDone(gsap, ScrollTrigger, ScrollSmoother);
        }
      }, 1000, 'onComingResizeHandler');
    }

    window.addEventListener('resize', onComingResizeHandler);

    return () => {
      console.log(`Coming: useGSAP 1: [${comingMount1}]: [clean]`);

      window.removeEventListener('resize', onComingResizeHandler);
    }
  }, {scope: comingRef});

  useGSAP((context, contextSafe) => {
    comingMount2++;
    console.log(`Coming: useGSAP 2: [${comingMount1}-${comingMount2}]: [execute]: [appLoaded(${appLoaded}), loadingOn(${loadingOn}), pageChangeOn.coming(${pageChangeOn.coming}), pageOn.coming(${pageOn.coming})]`);

    if(appLoaded) {
      if(pageChangeOn.coming) {
        scrollResizeControlClear(gsap, ScrollTrigger, Observer, ScrollSmoother);
        scrollResizeControlMake(gsap, ScrollTrigger, Observer, ScrollSmoother, 'coming');
        smoother.paused(true);

        setPageChangeOn({...pageInitState});
        setPageOn({...pageInitState, coming: true});
       }
       else if (pageOn.coming) {
        smoother.paused(false);

        ///// transition: during: contents show
        gsap.to('.page-coming .sector.hero .container-in', {duration: 0.2, opacity: 1, ease: 'power1.in'});

        comingInit(gsap);
        comingScrollMake(gsap, ScrollTrigger, ScrollSmoother);

        comingReady = true;
      }
    }

    return () => {
      console.log(`Coming: useGSAP 2: [${comingMount1}-${comingMount2}]: [clean]: [appLoaded(${appLoaded}), loadingOn(${loadingOn}), pageChangeOn.coming(${pageChangeOn.coming}), pageOn.coming(${pageOn.coming})]: cleanup`);

      comingReady = false;

      // if(appLoaded) { }
    }
  }, {scope: comingRef, dependencies: [appLoaded, pageChangeOn.coming, pageOn.coming], revertOnUpdate: true});

  return (
    <div className="part page page-coming" ref={comingRef}>
      <div className="part-in">
        <section className="sector sector-h-full hero">
          <div className="container container-w-full container-w-no-gutter-out">
            <div className="container-in">

              <div className="contents-wrapper">

                <div className="board board1"></div>

                <div className="video-container">
                  <video ref={videoRef} className="video-bg" src={videoBg} type={"video/mp4"} autoPlay playsInline loop />              
                </div>

                <div className="board board2"></div>
                
                <div className="sector-copies">
                  <h1 className="sector-copy title">COMING SOON</h1>
                  <p className="sector-copy sentence">Something great is on the way. Stay&nbsp;Tuned.</p>
                  {/* <p>There will be something very awesome. Stay Tuned.</p>
                  <p>Currently turning complex designs into clean, responsive pixel perfection. Stay Tuned.</p> */}
                  <div className="button-container">
                    <div className="button-wrap">
                      <div className="button">
                        <Link className="button-link" to="/"><span className="button-copy">Back to Home</span></Link>
                        {/* <span className="button-link"><span className="button-copy">Back to Home</span></span> */}
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default ComingSoon;